var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavSidebarCollapseAndExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80344 5.13807C6.06379 4.87772 6.06379 4.45561 5.80344 4.19526C5.54309 3.93491 5.12098 3.93491 4.86063 4.19526L1.52729 7.5286C1.26694 7.78894 1.26694 8.21106 1.52729 8.4714L4.86063 11.8047C5.12098 12.0651 5.54309 12.0651 5.80344 11.8047C6.06379 11.5444 6.06379 11.1223 5.80344 10.8619L2.94151 8L5.80344 5.13807Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1368 4.19526C10.8764 3.93491 10.4543 3.93491 10.194 4.19526C9.93361 4.45561 9.93361 4.87772 10.194 5.13807L13.0559 8L10.194 10.8619C9.93361 11.1223 9.93361 11.5444 10.194 11.8047C10.4543 12.0651 10.8764 12.0651 11.1368 11.8047L14.4701 8.4714C14.7305 8.21106 14.7305 7.78894 14.4701 7.5286L11.1368 4.19526Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSidebarCollapseAndExpandIcon);
export default __webpack_public_path__ + "static/media/nav_sidebar_collapse-and-expand_icon.c8387a85669e2f2af901e02fa64b0b2a.svg";
export { ForwardRef as ReactComponent };